export default __webpack_public_path__ + "static/media/068-puffer fish.dc004968.svg";